/* tslint:disable */
/* eslint-disable */
/**
 * Portal Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const ExperienceLevel = {
    Junior: 'Junior',
    Medior: 'Medior',
    Senior: 'Senior'
};
export function instanceOfExperienceLevel(value) {
    for (const key in ExperienceLevel) {
        if (Object.prototype.hasOwnProperty.call(ExperienceLevel, key)) {
            if (ExperienceLevel[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function ExperienceLevelFromJSON(json) {
    return ExperienceLevelFromJSONTyped(json, false);
}
export function ExperienceLevelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ExperienceLevelToJSON(value) {
    return value;
}
export function ExperienceLevelToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
